import Section from '../Section';

export default class ProductRecommendations extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.load();
  }

    load = () => {
      // Read product id from data attribute
      var productId = this.element.dataset.productId;
      // Read limit from data attribute
      var limit = this.element.dataset.limit;
      // Get section id
      var sectionId = this.element.dataset.wethemeSectionId;
      // Build request URL
      var requestUrl = `${this.element.dataset.recommendationsUrl}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = () => this.onLoad(request);
      request.send();
    }

    /**
     * @param {XMLHttpRequest} request
     */
    onLoad = (request) => {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        // FIXME this could overwrite `this`, do we need to address that?
        this.element.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        this.gridSwatches();
      } else {
        console.warn('Recommend products cannot be loaded:', request.responseText);
      }
    }

    gridSwatches = () => {
      ['change', 'mouseover'].forEach(ev => {
        $('.indiv-product__swatches').find('input').on(ev, function () {
          var updateImage = $(this).attr('data-href');
          var targetImage = $(this).closest('.indiv-product').find('.grid__image img');
  
          targetImage.attr({ src: updateImage });
          targetImage.attr({ srcset: updateImage });
          targetImage.data({ lowsrc: updateImage });
          targetImage.data({ srcset: updateImage });
        });
      });
    }
}
